"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=MailgunEvent.js.map